module.exports = __webpack_public_path__ + "static/media/evento-carioca-anime-redes-sociais-facebook-768x591.17a3c559.jpg";